<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
                <div class="col-sm-5">
                </div>
                <div class="col-sm-7">
                  <div class="float-sm-end d-flex">
                    <div class="text-sm-right">
                      <button type="button" class="btn btn-success btn-rounded mb-2 mr-2" @click="newTemplate()">
                        <i class="mdi mdi-plus mr-1"></i> Novo Template
                      </button>
                    </div>
                  </div>
              </div>
              <!-- end col-->
            </div>
            <div class="table-responsive">
              <table class="table table-centered table-nowrap table-hover">
                <thead>
                  <tr>
                    <th width="15%">Remetente</th>
                    <th width="15%">E-mail Remetente</th>
                    <th width="50%">Assunto</th>
                    <th width="10%">#</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="list in emailtemplates" :key="list.id" class="link">
                    <td @click="editTemplate(list.id)">{{ list.from_name }}</td>
                    <td @click="editTemplate(list.id)">{{ list.from_email }}</td>
                    <td @click="editTemplate(list.id)">{{ list.subject }}</td>
                    <td>
                      <button type="button" @click="copyTemplate(list)" class="link btn btn-outline-primary btn-sm" title="Duplicar template">
                        <i class='bx bx-copy-alt'></i>
                      </button>
                      <button type="button" @click="deleteTemplate(list.id)" class="link btn btn-outline-danger btn-sm ml-2" title="Excluir template">
                        <i class='bx bx-trash-alt'></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" @input="updateList"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<script>
import Swal from 'sweetalert2'
import Layout from '@/components/layout/vertical'
import PageHeader from '@/components/page-header'
import appConfig from '@/app.config'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { mapActions, mapState } from 'vuex'
export default {
  components: {
    Layout,
    PageHeader
  },
  name: 'templateemail',
  page: {
    title: 'E-mails',
    meta: [{
      name: 'description',
      content: appConfig.description
    }]
  },
  data () {
    return {
      modalForm: false,
      modalRule: false,
      params: {},
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      statusLabel: ['Inativo', 'Ativo'],
      submitted: false,
      title: 'E-mails',
      items: [{
        text: 'E-mails'
      },
      {
        text: 'Configurações',
        active: true
      }
      ]
    }
  },
  mounted () {
    this.updateList()
    this.totalRows = this.pagination.total
    this.currentPage = this.pagination.current_page
    this.loading = false
  },
  computed: {
    ...mapState('settings', ['setting']),
    ...mapState('emailTemplate', ['emailtemplates', 'pagination']),
    rows () {
      return this.pagination.total
    }
  },
  methods: {
    ...mapActions('emailTemplate', {
      getAll: 'getAll',
      changeStatus: 'changeStatus',
      setCopiedTemplate: 'setCopiedTemplate',
      destroyTemplate: 'deleteTemplate'
    }),
    formRules () {
      this.$refs.formRule.open()
      this.modalRule = true
    },
    newTemplate () {
      this.$router.push({
        name: 'template-email-new'
      })
    },
    editTemplate (id) {
      this.$router.push({
        name: 'template-email-edit',
        params: {
          id: id
        }
      })
    },
    copyTemplate (template) {
      const copiedTemplate = {
        ...template,
        subject: `${template.subject} (Cópia)`,
        id: undefined
      }
      this.setCopiedTemplate(copiedTemplate)
      this.$router.push({ name: 'template-email-new' })
    },
    async toggleStatus (id) {
      try {
        await this.changeStatus(id).then((res) => {
          let message = 'Sucesso: Status atualizado com sucesso.'
          let delay = 2500
          successMessage(message, delay)
          this.updateList()
        }).catch((error) => {
          errorMessage('Alerta: ' + error.message)
        })
      } catch (err) {
        console.log(err)
        errorMessage('Alerta: ' + err.response.data.message)
      }
    },
    deleteTemplate (id) {
      Swal.fire({
        title: 'Você tem certeza ?',
        text: 'Essa ação não poderá ser revertida',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f46a6a',
        cancelButtonColor: '#4a4848',
        cancelButtonText: 'CANCELAR',
        confirmButtonText: 'SIM, DESEJO EXCLUIR!'
      }).then(result => {
        if (result.value) {
          try {
            this.destroyTemplate(id).then((res) => {
              successMessage('Sucesso: Template excluído com sucesso.', 2500)
              this.updateList()
            }).catch((err) => {
              errorMessage('Alerta: ' + err.message)
            })
          } catch (err) {
            errorMessage('Alerta: ' + err.response.data.message)
          }
        }
      })
    },
    getReport (filter) {
      let params = {
        search: this.search || null,
        limit: this.perPage,
        page: this.currentPage,
        domain: filter.domain || null,
        city: filter.city || null,
        district: filter.district || null,
        created_start: filter.created_start ? this.$moment(filter.created_start).format('YYYY-MM-DD') : null,
        created_end: filter.created_end ? this.$moment(filter.created_end).format('YYYY-MM-DD') : null,
        status: filter.status || null
      }
      this.params = params
      let loeader = this.$loading.show()
      this.getAll(this.params).then((res) => {
        // this.participants = res.data
        this.totalRows = this.pagination.total
        this.currentPage = this.pagination.current_page
        loeader.hide()
      }).catch(error => {
        console.log(error)
        loeader.hide()
      })
    },
    doSearch () {
      this.params = { ...this.params, search: this.search }
      this.getReport(this.params)
    },
    updateList () {
      this.getReport(this.params)
    }
  },
  watch: {
    // currentPage () { this.updateList() }
    // total () { this.updateList() },
  }
}
</script>
<style scoped>
.link { cursor: pointer; }
.swal2-popup {
  font-size: 11px !important;
}
.table-responsive { min-height: 400px;}
.float-sm-end { float: right }
</style>
